import { render, staticRenderFns } from "./ExtendedCountdown.vue?vue&type=template&id=245ffdb5&scoped=true&"
import script from "./ExtendedCountdown.vue?vue&type=script&lang=ts&"
export * from "./ExtendedCountdown.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedCountdown.vue?vue&type=style&index=0&id=245ffdb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ffdb5",
  null
  
)

export default component.exports